import { match } from 'ts-pattern';
import type { ExecutionOperation, OperationData, zCodeOp } from './types';
import type { z } from 'zod';

export const overrideTimeouts = (operation: OperationData, timeoutMs: number): OperationData => {
  return {
    ...operation,
    operation: match(operation.operation)
      .with(
        { operationType: 'ASSERTION' },
        { operationType: 'ACTION' },
        { operationType: 'NAVIGATION' },
        (operation) => ({
          ...operation,
          options: {
            ...operation.options,
            timeout: timeoutMs,
          },
        }),
      )
      .otherwise((operation) => operation),
  };
};

export const clearTimeoutOverride = (operation: OperationData): OperationData => {
  return {
    ...operation,
    operation: match(operation.operation)
      .with({ operationType: 'ASSERTION' }, { operationType: 'ACTION' }, { operationType: 'NAVIGATION' }, (op) => {
        const { timeout, ...remainingOptions } = op.options ?? {};
        return {
          ...op,
          // Set options to undefined if there are no other options instead of an empty object
          options: Object.keys(remainingOptions).length > 0 ? remainingOptions : undefined,
        };
      })
      .otherwise((op) => op),
  };
};

export const overrideTimeoutsForExecutionOperation = (
  operation: ExecutionOperation | z.infer<typeof zCodeOp>,
  timeoutMs: number,
) =>
  match(operation)
    .with(
      { operationType: 'ASSERTION' },
      { operationType: 'ACTION' },
      { operationType: 'NAVIGATION' },
      (operation) => ({
        ...operation,
        options: {
          ...operation.options,
          timeout: timeoutMs,
        },
      }),
    )
    .otherwise(() => operation);
